import React, { useState } from "react";
import { PayableCardHeader } from "../payable-card-header";
import { useSelector } from "react-redux";
import {
  getBiller,
  getSelectedPayableType,
  getPayableSession,
} from "selectors";
import { IBillerMessage } from "types/biller";
import { ContactAndTocFooter } from "components/ezpay/common/contact-and-toc-footer";
import { LookupsForm } from "../lookups-form";
import { WelcomeMessageBanner } from "components/ezpay/common/welcome-message-banner/welcome-message-banner";
import { WelcomeModal } from "components/ezpay/common/welcome-modal/welcome-modal";
import { useTranslation } from "react-i18next";
import {
  COMMON_NAMESPACE,
  LOOKUP_NAMESPACE,
  VALIDATE_NAMESPACE,
} from "constants/i18n-namespaces";
import { Navigate } from "react-router";
import routing from "routing";
import { getIsMobile } from "selectors/appState";
import triangleWarning from "assets/icons/triangle_exclamation.svg";

export interface ILookupsContainerProps {
  setBannerState: any;
}

export const LookupsContainer = (props: ILookupsContainerProps) => {
  const { setBannerState } = props;
  const { t, i18n } = useTranslation(VALIDATE_NAMESPACE);
  const biller = useSelector(getBiller);
  const [welcomeModalIsOpen, setWelcomeModalIsOpen] = useState(false);
  const welcomeMessageDisplayed = localStorage.getItem("welcomeMessage");
  let welcomeMessageShown = true;
  const isMobile = useSelector(getIsMobile);
  const [selectedLookupError, setSelectedLookupError] = useState(false);

  if (welcomeMessageDisplayed === null) {
    welcomeMessageShown = true;
    localStorage.setItem("welcomeMessage", "1");
  } else {
    welcomeMessageShown = false;
  }

  if (welcomeMessageShown) {
    setWelcomeModalIsOpen(true);
  }

  const setWelcomeModalIsOpenToTrue = () => {
    setWelcomeModalIsOpen(true);
  };

  function RemoveOverflow() {
    document.body.style.removeProperty("overflow");
  }
  const setWelcomeModalIsOpenToFalse = () => {
    setWelcomeModalIsOpen(false);
    window.setTimeout(RemoveOverflow, 50);
  };

  const billerMessageProperties = biller?.properties?.find((element) => {
    return element.name === "InstanceConfiguration";
  }) as IBillerMessage;

  const billerMessageEnabled =
    billerMessageProperties?.properties?.billerMessageWebEnabled === "true";

  const billerMessage = () => {
    if (billerMessageEnabled) {
      try {
        const billerMessage = JSON.parse(
          billerMessageProperties?.properties.billerMessageWeb
        );
        const msg = billerMessage.find(
          (msg: { language: string }) => msg.language === i18n.language
        );
        return msg?.value;
      } catch (error) {
        return undefined;
      }
    }
  };

  const payableTypeFromStore = useSelector(getSelectedPayableType);
  const payableSession = useSelector(getPayableSession);

  const selectedPayableType =
    payableSession?.payableType ?? payableTypeFromStore;

  if (!selectedPayableType) {
    return <Navigate to={routing.index()} />;
  }

  return (
    <div>
      <div className="ez-pay-payable-frame">
        <PayableCardHeader />
        {selectedLookupError && (
          <div className="validate-error">
            <img
              src={triangleWarning}
              alt={`${t("invalid-entry")}`}
              className="validate-error-icon"
            />
            <div>
              <div className="validation-error-header">
                {t("invalid-entry")}
              </div>
              <div className="validation-error-message">
                {t("lookup-field-required", { ns: LOOKUP_NAMESPACE })}
              </div>
            </div>
          </div>
        )}

        {/* banner for Biller Message*/}
        {billerMessageEnabled && billerMessage != undefined && (
          <div className="welcome-banner-div">
            <WelcomeMessageBanner
              messageLabel={t("welcome-banner-title")}
              linkText={`${t("view", { ns: COMMON_NAMESPACE })}`}
              onClick={setWelcomeModalIsOpenToTrue}
            ></WelcomeMessageBanner>
          </div>
        )}

        {billerMessageEnabled && billerMessage != undefined && (
          <WelcomeModal
            headingText={t("biller-message-label", {
              billerName: biller.billerName,
            })}
            open={welcomeModalIsOpen}
            onClose={setWelcomeModalIsOpenToFalse}
            infoText={billerMessage()}
            closeIcon={isMobile}
            closeButtonLabel={`${t("close", { ns: COMMON_NAMESPACE })}`}
          />
        )}

        {biller && (
          <LookupsForm
            setBannerState={setBannerState}
            biller={biller}
            selectedPayableType={selectedPayableType}
            selectedLookupError={selectedLookupError}
            setSelectedLookupError={setSelectedLookupError}
          />
        )}
        <ContactAndTocFooter biller={biller} />
      </div>
    </div>
  );
};
